const CDN_BASE = "https://genres.nyc3.cdn.digitaloceanspaces.com/sites/artly/templates/";

export const realisticTemplates = [
  { id: "cumshot", title: "Cumshot", video: "cumshot_small.mp4" },
  { id: "blowjob", title: "Blowjob", video: "blowjob_small.mp4" },
  { id: "titfuck", title: "Titfuck", video: "titfuck_small.mp4" },
  { id: "twerking", title: "Twerking", video: "twerking_small.mp4" },
  { id: "reverse_cowgirl", title: "Cowgirl", video: "cowgirl_small.mp4" },
  { id: "fingering", title: "Fingering", video: "fingering_small.mp4" },
  { id: "pov_insertion", title: "POV Insertion", video: "pov_insertion_small.mp4" },
  { id: "rimming", title: "Rimming", video: "rimming_small.mp4" },
  { id: "posing", title: "Posing", video: "posing_small.mp4" },
  { id: "full_nelson", title: "Full Nelson", video: "full_nelson_small.mp4" },
  { id: "show_feet", title: "Show Feet", video: "show_feet_small.mp4" },
  { id: "fisting", title: "Fisting", video: "fisting_small.mp4" },
];

export const animeTemplates = [
  { id: "posing_anime", title: "Posing", video: "posing_anime_small.mp4" },
  { id: "blowjob_anime", title: "Blowjob", video: "blowjob_anime_small.mp4" },
  { id: "titfuck_anime", title: "Titfuck", video: "titfuck_anime_small.mp4" },
  { id: "twerking_anime", title: "Twerking", video: "twerking_anime_small.mp4" },
  { id: "reverse_cowgirl_anime", title: "Cowgirl", video: "reverse_cowgirl_anime_small.mp4" },
  { id: "full_nelson_anime", title: "Full Nelson", video: "full_nelson_anime_small.mp4" },
];

export const getVideoUrl = (filename) => `${CDN_BASE}${filename}`;
